const SET_FORGOT_PASSWORD_USER = (state, payload) => { state.forgotPasswordUser = payload }
const RESET_FORGOT_PASSWORD_USER = (state) => { state.forgotPasswordUser = '' }

const SET_FORGOT_PASSWORD_MESSAGE = (state, payload) => { state.forgotPasswordMessage = payload }
const RESET_FORGOT_PASSWORD_MESSAGE = (state) => { state.forgotPasswordMessage = '' }

const SET_FORGOT_PASSWORD_ERROR = (state, payload) => { state.forgotPasswordError = payload }
const RESET_FORGOT_PASSWORD_ERROR = (state) => { state.forgotPasswordError = '' }

const SET_RESET_PASSWORD_MESSAGE = (state, payload) => { state.resetPasswordMessage = payload }
const RESET_RESET_PASSWORD_MESSAGE = (state) => { state.resetPasswordMessage = '' }

const SET_RESET_PASSWORD_ERROR = (state, payload) => { state.resetPasswordError = payload }
const RESET_RESET_PASSWORD_ERROR = (state) => { state.resetPasswordError = '' }

export default {
    SET_FORGOT_PASSWORD_USER,
    RESET_FORGOT_PASSWORD_USER,

    SET_FORGOT_PASSWORD_MESSAGE,
    RESET_FORGOT_PASSWORD_MESSAGE,

    SET_FORGOT_PASSWORD_ERROR,
    RESET_FORGOT_PASSWORD_ERROR,

    SET_RESET_PASSWORD_MESSAGE,
    RESET_RESET_PASSWORD_MESSAGE,

    SET_RESET_PASSWORD_ERROR,
    RESET_RESET_PASSWORD_ERROR,

    
}